import Vue from 'vue'
import util from '@/util'

const state = {
  contador: 0,
  siniestros: []
}

const getters = {
  siniestros(state) {
    return state.siniestros;
  },
  contadorSiniestros(state) {
    return state.contador;
  }
}

const actions = {
  ordenarSiniestros(context, payload) {
    context.commit("ordenarSiniestros", payload.orden);
  },
  clearSiniestros(context) {
    context.commit("clearSiniestros");
    context.commit("setContadorSiniestros", 0);
  },
  setSiniestros(context, payload) {
    context.commit("setSiniestros", payload.siniestros);
  },
  addSiniestro(context, payload) {
    context.commit("addSiniestro", payload.siniestro);
  },
  setContadorSiniestros(context, payload) {
    context.commit("setContadorSiniestros", payload.contador);
  },
  loadSiniestros(context, payload) {
    let url = context.getters.urlBase + 'siniestros?' + util.objToQuery(payload.params);
    let responses = [];
    Vue.http.get(url).then(
      (response) => {
        responses.push(response);
        context.commit("setSiniestros", response.body.items);

        for(let i = 2; i <= response.body.totalPages; i++){
          payload.params.page = i;
          let url = context.getters.urlBase + 'siniestros?' + util.objToQuery(payload.params);
          Vue.http.get(url).then(
            (response) => {
              responses.push(response);
              response.body.items.forEach(function(poliza){
                context.commit("addSiniestro", poliza);
              });
            },
            (error) => {
              payload.callbackError(error);
            }
          );
        }

        if (payload.callbackOk) {
          payload.callbackOk(responses);
        }
      },
      (error) => {
        this.loading = false;
        if (payload.callbackOk) {
          payload.callbackError(error);
        }
      }
    );
  }
}

const mutations = {
  ordenarSiniestros(state, orden) {
    state.siniestros = _.orderBy(state.siniestros, orden.sortKey, orden.reverse ? 'desc' : 'asc');
  },
  setSiniestros(state, sineistros) {
    state.siniestros = sineistros;
  },
  clearSiniestros(state) {
    state.siniestros = [];
  },
  addSiniestro(state, siniestro) {
    state.siniestros.push(siniestro);
  },
  setContadorSiniestros(state, contador) {
    state.contador = contador;
  }
}


export default {
    state,
    getters,
    mutations,
    actions
}
